/* unplugin-vue-components disabled */import script from "./Cgzy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cgzy.vue?vue&type=script&lang=ts&setup=true"

import "./Cgzy.vue?vue&type=style&index=0&id=508a3d8c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508a3d8c"]])

export default __exports__